import { useEffect } from "react";
import { useAuthActions } from "@convex-dev/auth/react";
import { toast } from "sonner";
import { listenForDesktopOAuthCallback } from "@/lib/desktop/google-oauth-desktop";

/**
 * Monta (una sola vez, solo en la app de escritorio) el listener del deep link
 * de OAuth de Google. Vive alto en el árbol para capturar el callback aunque el
 * usuario haya navegado. No renderiza UI; en web/on-prem es un no-op.
 */
export function DesktopOAuthListener() {
  const { signIn } = useAuthActions();

  useEffect(() => {
    let active = true;
    let unlisten: (() => void) | undefined;

    void listenForDesktopOAuthCallback(signIn, () =>
      toast.error("No se pudo completar el inicio de sesión con Google."),
    ).then((u) => {
      if (active) unlisten = u;
      else u(); // se desmontó antes de resolver: limpiar de inmediato
    });

    return () => {
      active = false;
      unlisten?.();
    };
  }, [signIn]);

  return null;
}
